import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "kpi-head" }
const _hoisted_2 = { class: "kpi-period-wrap" }
const _hoisted_3 = { class: "kpi-period" }
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "kpi-period-badge",
  title: "Existem conversas pendentes de resolução em semanas anteriores."
}
const _hoisted_6 = { class: "kpi-row" }
const _hoisted_7 = { class: "kpi-top" }
const _hoisted_8 = {
  key: 0,
  class: "skel skel-lg"
}
const _hoisted_9 = { class: "kpi-foot" }
const _hoisted_10 = {
  key: 0,
  class: "skel skel-pill"
}
const _hoisted_11 = {
  key: 1,
  class: "tag neu"
}
const _hoisted_12 = { class: "kpi-top" }
const _hoisted_13 = {
  key: 0,
  class: "skel skel-lg"
}
const _hoisted_14 = {
  key: 1,
  class: "kpi-val"
}
const _hoisted_15 = { class: "kpi-foot" }
const _hoisted_16 = {
  key: 0,
  class: "skel skel-pill"
}
const _hoisted_17 = {
  key: 1,
  class: "tag info"
}
const _hoisted_18 = { class: "kpi-top" }
const _hoisted_19 = {
  key: 0,
  class: "skel skel-lg"
}
const _hoisted_20 = {
  key: 1,
  class: "kpi-val"
}
const _hoisted_21 = { class: "kpi-foot" }
const _hoisted_22 = {
  key: 0,
  class: "skel skel-pill"
}
const _hoisted_23 = {
  key: 1,
  class: "tag night"
}
const _hoisted_24 = { class: "kpi-top" }
const _hoisted_25 = {
  key: 0,
  class: "skel skel-lg"
}
const _hoisted_26 = {
  key: 1,
  class: "kpi-val"
}
const _hoisted_27 = { class: "kpi-foot" }
const _hoisted_28 = {
  key: 0,
  class: "skel skel-pill"
}
const _hoisted_29 = {
  key: 1,
  class: "tag warn"
}
const _hoisted_30 = { class: "kpi-top" }
const _hoisted_31 = {
  key: 0,
  class: "skel skel-lg"
}
const _hoisted_32 = {
  key: 1,
  class: "kpi-val"
}
const _hoisted_33 = { class: "kpi-foot" }
const _hoisted_34 = {
  key: 0,
  class: "skel skel-pill"
}
const _hoisted_35 = {
  key: 1,
  class: "tag up"
}

import { ref, watch, onMounted } from 'vue'

export type VisaoGeralPeriodo = 'week' | 'month'


export default /*@__PURE__*/_defineComponent({
  __name: 'KpiGrid',
  props: {
    total: {},
    open: {},
    emAvaliacao: {},
    unassigned: {},
    resolved: {},
    resPct: {},
    periodo: {},
    loading: { type: Boolean },
    scopeReady: { type: Boolean },
    monthPendingCount: {}
  },
  emits: ["update:periodo"],
  setup(__props: any) {

const props = __props



const periodOptions: { value: VisaoGeralPeriodo; label: string }[] = [
  { value: 'week',  label: 'Esta semana' },
  { value: 'month', label: 'Mês' },
]

const ready = ref(false)
const displayTotal       = ref(0)
const displayOpen        = ref(0)
const displayEmAvaliacao = ref(0)
const displayUnassigned  = ref(0)
const displayResolved    = ref(0)

function animate(from: number, to: number, setter: (v: number) => void) {
  const dur = 650, start = performance.now()
  const step = (now: number) => {
    const t = Math.min((now - start) / dur, 1)
    const e = 1 - Math.pow(1 - t, 3)
    setter(Math.round(from + (to - from) * e))
    if (t < 1) requestAnimationFrame(step)
    else setter(to)
  }
  requestAnimationFrame(step)
}

watch(() => props.total,       (to, from = 0) => animate(from, to, v => displayTotal.value = v),       { immediate: true })
watch(() => props.open,        (to, from = 0) => animate(from, to, v => displayOpen.value = v),        { immediate: true })
watch(() => props.emAvaliacao, (to, from = 0) => animate(from, to, v => displayEmAvaliacao.value = v), { immediate: true })
watch(() => props.unassigned,  (to, from = 0) => animate(from, to, v => displayUnassigned.value = v),  { immediate: true })
watch(() => props.resolved,    (to, from = 0) => animate(from, to, v => displayResolved.value = v),    { immediate: true })

onMounted(() => {
  setTimeout(() => { ready.value = true }, 50)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "sec" }, "Visão Geral", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "filter-label" }, [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
          ]),
          _createTextVNode(" Período ")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(periodOptions, (opt) => {
            return _createElementVNode("button", {
              key: opt.value,
              type: "button",
              class: _normalizeClass(["kpi-period-btn", { active: __props.periodo === opt.value }]),
              disabled: __props.loading,
              onClick: ($event: any) => (_ctx.$emit('update:periodo', opt.value))
            }, [
              _createTextVNode(_toDisplayString(opt.label) + " ", 1),
              (opt.value === 'month' && __props.monthPendingCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "!"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["kpi c-red", { in: ready.value }])
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "kpi-lbl" }, "Total", -1)),
            (__props.scopeReady === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "kpi-val",
                  ref: "elTotal"
                }, _toDisplayString(displayTotal.value), 513))
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "kpi-icon" }, [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
            ])
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (__props.scopeReady === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, "Conversas"))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["kpi c-blue", { in: ready.value }]),
        style: {"transition-delay":"70ms"}
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "kpi-lbl" }, "Abertas", -1)),
            (__props.scopeReady === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(displayOpen.value), 1))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "kpi-icon" }, [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              }),
              _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
            ])
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_15, [
          (__props.scopeReady === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, "Em andamento"))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["kpi c-night", { in: ready.value }]),
        style: {"transition-delay":"105ms"}
      }, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "kpi-lbl" }, "Em Avaliação", -1)),
            (__props.scopeReady === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(displayEmAvaliacao.value), 1))
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "kpi-icon" }, [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              })
            ])
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_21, [
          (__props.scopeReady === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22))
            : (_openBlock(), _createElementBlock("span", _hoisted_23, "Aguardando CSAT"))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["kpi c-orange", { in: ready.value }]),
        style: {"transition-delay":"140ms"}
      }, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "kpi-lbl" }, "Sem agente", -1)),
            (__props.scopeReady === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(displayUnassigned.value), 1))
          ]),
          _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"kpi-icon\" data-v-5223a7c5><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5223a7c5><path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\" data-v-5223a7c5></path><circle cx=\"12\" cy=\"7\" r=\"4\" data-v-5223a7c5></circle><line x1=\"18\" y1=\"8\" x2=\"23\" y2=\"13\" data-v-5223a7c5></line><line x1=\"23\" y1=\"8\" x2=\"18\" y2=\"13\" data-v-5223a7c5></line></svg></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_27, [
          (__props.scopeReady === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_28))
            : (_openBlock(), _createElementBlock("span", _hoisted_29, "Precisam atenção"))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["kpi c-green", { in: ready.value }]),
        style: {"transition-delay":"210ms"}
      }, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "kpi-lbl" }, "Resolvidas", -1)),
            (__props.scopeReady === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(displayResolved.value), 1))
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "kpi-icon" }, [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
              _createElementVNode("polyline", { points: "22 4 12 14.01 9 11.01" })
            ])
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_33, [
          (__props.scopeReady === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_34))
            : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(__props.resPct) + "% resolvidas", 1))
        ])
      ], 2)
    ])
  ], 64))
}
}

})